import React from 'react';

export const DEVICES_ASSIGNED_COOKIE = 'DEVICES_ASSIGNED';
export const LOCAL_STORAGE_DEVICES = 'privateDeviceManagement';

export const DEVICE_STATES = Object.freeze({
  AVAILABLE: {
    color: 'green',
    text: 'Available',
  },
  IN_USE: {
    color: 'orange',
    text: 'In Use',
  },
  CLEANING: {
    color: 'red',
    text: 'Cleaning',
  },
  REBOOTING: {
    color: 'red',
    text: 'Rebooting',
  },
  MAINTENANCE: {
    color: 'red',
    text: 'Maintenance',
  },
  OFFLINE: {
    color: 'red',
    text: 'Offline',
  },
});

export const EDIT_DEVICE_SETTINGS_MODAL = 'editDeviceSettingsModal';

export const APP_ALLOWLIST_TOOLTIP = 'This setting allows specific applications to remain on the devices.';

export const AppAllowListInputHelper : React.FC = () => (
  <>
    <p>
      Enter the package name (Android) or bundle ID (iOS) of the apps you want to allowlist.
    </p>
    {' '}
    <p>
      e.g.
      {' '}
      <i>com.apps.app1,com.ios.app2</i>
    </p>
  </>
);

export const SystemAppAllowlistInputHelper : React.FC = () => (
  <>
    <p>
      Enter the bundle ID of the apps you want to allowlist.
    </p>
    {' '}
    <p>
      e.g.
      {' '}
      <i>com.apps.app1,com.ios.app2</i>
    </p>

  </>
);

export const AccountAllowlistInputHelper : React.FC = () => (
  <>
    <p>
      Enter the email address of the accounts you want to allowlist.
    </p>
    {' '}
    <p>
      e.g.
      {' '}
      <i>foo@bar.com,dummy@mail.de</i>
    </p>
  </>
);

export const SkipCleaningFoldersHelper : React.FC = () => (
  <>
    <p>
      Enter the file/folder paths for data you want to keep.
    </p>
    {' '}
    <p>
      e.g.
      {' '}
      <i>/Downloads,/Documents/TempForTest,/data/com.wavelink.velocity/files</i>
    </p>
  </>
);

export const SYSTEM_APP_ALLOWLIST_TOOLTIP = 'This setting allows specific system applications to remain on the devices.';
export const ACCOUNT_ALLOWLIST_TOOLTIP = 'This setting keeps your Apple ID or Google account logged in on your devices.';
export const SKIP_CLEANING_FOLDERS_TOOLTIP = 'This setting keeps data from your specific folder and file paths';
export const APPLE_PAY_SUPPORT_TOOLTIP = 'Sets up the device for Apple Payment testing. ';

export const MAX_ALLOWLIST_SIZE = 10;
